import React from 'react'
import Navbar from '../../components/Navbar'

const ContactPage = () => {
  return (
    <div>
      <p>ContactPage</p>
    </div>
  )
}

export default ContactPage